require('lodash');

"use strict";

const Nav = () => {
    const init = () => {
        $(document).ready(function() {
            let $navbar = $('.navbar-collapse');
            $('header .hamburger').click(function() {
                if ($(this).hasClass('is-active')) {
                    $(this).removeClass('is-active');
                    $navbar.removeClass('show');
                } else {
                    $(this).addClass('is-active');
                    $navbar.addClass('show');
                }
            });

            const onScroll = function() {
                var scroll = $(window).scrollTop();

                if (scroll >= 100) {
                    $("nav.navbar").addClass("show-background");
                } else {
                    $("nav.navbar").removeClass("show-background");
                }
            };
            $(window).on('scroll', _.debounce(onScroll, 400));
            onScroll();
        });
    };

    return {
        init:init
    };
};

export default Nav;